<template>

  <HomeView></HomeView>

</template>

<script>
import HomeView from './components/Home.vue'

export default {
  name: 'App',
  components: {
    HomeView
  }
}


</script>

<style>
#bee_game_center {
  background-color: #fff;
  padding: 20px;
  transition: transform 700ms;
  border: none;
  flex-direction: column;
  justify-content: center;
  display: flex;
  margin-top: 36px;
  border-radius: 8px;
}
</style>
